export const RIPLEY_BANNERS = {
  STICKY: {
    BANK: {
      DESKTOP: {
        EXPANDED_ON:
          process.env.REACT_APP_BANNER_BANK_DESKTOP_EXPANDED_ON === 'true',
        HIDER_ON: process.env.REACT_APP_BANNER_BANK_DESKTOP_HIDER_ON === 'true',
        SHOW_BANNER_ON:
          process.env.REACT_APP_BANNER_BANK_DESKTOP_BANNER_SHOW_ON === 'true',
        TEXT_ON_TAB: process.env.REACT_APP_BANNER_BANK_DESKTOP_TEXT_ON_TAB,
        IMG: {
          WIDTH: process.env.REACT_APP_BANNER_BANK_DESKTOP_IMG_WIDTH,
          HEIGHT: process.env.REACT_APP_BANNER_BANK_DESKTOP_IMG_HEIGHT,
        },
      },
      MOBILE: {
        EXPANDED_ON:
          process.env.REACT_APP_BANNER_BANK_MOBILE_EXPANDED_ON === 'true',
        HIDER_ON: process.env.REACT_APP_BANNER_BANK_MOBILE_HIDER_ON === 'true',
        SHOW_BANNER_ON:
          process.env.REACT_APP_BANNER_BANK_MOBILE_BANNER_SHOW_ON === 'true',
        TEXT_ON_TAB: process.env.REACT_APP_BANNER_BANK_MOBILE_TEXT_ON_TAB,
        IMG: {
          WIDTH: process.env.REACT_APP_BANNER_BANK_MOBILE_IMG_WIDTH,
          HEIGHT: process.env.REACT_APP_BANNER_BANK_MOBILE_IMG_HEIGHT,
        },
      },
    },
  },
};